if(window.location.href.indexOf('/tools/recurring/')){
  var slickLink = '//www.southbeachskinlab.com/cdn/shop/t/130/assets/slick.min.js?v=89980774482270015571763053034';
  $.getScript(slickLink, function() {
  });
}

window.theme = window.theme || {};

// Handlebars.registerHelper('ifEquals', function(arg1, arg2) {
//   return (arg1 == arg2) ? (this) : !(this);
// });
// Handlebars.registerHelper('ifLess', function(arg1, arg2) {
//   return (arg1 < arg2) ? (this) : !(this);
// });

theme.Currency = (function(){
  var moneyFormat = $('#shop_currency_val').text();

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();
var open2 = false;
function getAjaxCart2() {
  $('.discount-step').load('/cart?view=drawer' + ' .discount-cart-shipping', function(){
//     window.history.pushState({}, null);
  });
  $('#cart_container_id').load('/cart?view=drawer' + ' .cartDrawer', function(){
     
    var SideContentHeight = $('.block-cart-header').innerHeight() + $('.block-cart-footer').innerHeight();
    $('#cart_container_id .cart-middle-items').css('height', $(window).height() - SideContentHeight + 'px');
    
    if ($('#cart_accessories .upsellwrap .upsell_grid').length == 0){
      $('#cart_accessories').hide();
    }
    else{
      if($('.upsellwrap').length > 0){
        $('.upsellwrap').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
          arrows: true,
          responsive: [
            {
              breakpoint: 750,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: '12px',
              }
            }
          ]
        });
      }
    }
   
    $('.cart-content-here').removeClass('wc_cart_loader');
//     window.history.pushState({}, null);
    
  });
  
}

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $){
  var shop_currency = $('#shop_currency_val').text();
  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, validateQty;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options){

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      cartContainer      : '#cart_container_id',
      addToCartSelector  : 'button[type="submit"]',
      cartCountSelector  : '.cart_qty_cls',
      cartCostSelector   : null,
      moneyFormat        : shop_currency,
      disableAjaxCart    : false,
      enableQtySelectors : false
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);

    // General Selectors
    $body = $('body');

    // Track cart activity status
    isUpdating = false;

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ''));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(evt.target, itemAddedCallback, itemErrorCallback)
    });
  };

  itemAddedCallback = function (product) {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart){
    // Update quantity and price
    updateCountPrice(cart);

    getAjaxCart2();

    
    /*if(cart.item_count != '' || cart.item_count != null || cart.item_count != undefined || cart.item_count > 0){
      $('.cart_qty_cls').text(cart.item_count);
    }*/

  };
    
  buildCart = function(cart){
    // Start with a fresh cart div
    $cartContainer.empty();
    
    
	
    // Show empty cart
    
    if (cart.item_count == 0) {
      $cartContainer.append('<div class="empty_cart"><h3 class="empty_cart_slide_cls"> Your cart is currently empty.</h3><div class="view-cart"><a href="/collections/all" class="signpost-button">Shop now</a></div></div>');
   //   $('.discount-step').hide();
      cartCallback(cart);
      return;
    }else{
     // $('.discount-step').show();
//       $('.shipping-method').show();
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
             delete cartItem.properties[key];
           }
        });
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, shop_currency),
        lineprice: Shopify.formatMoney(cartItem.line_price, shop_currency),
        discountedPrice: Shopify.formatMoney((cartItem.price - (cartItem.total_discount/cartItem.quantity)), shop_currency) ,
        discounts: cartItem.discounts,
        discountsApplied: cartItem.price === (cartItem.price - cartItem.total_discount) ? false : true,
        vendor: cartItem.vendor
      };
      
      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "Translation missing: en.cart.general.savings_html".replace('[savings]', theme.Currency.formatMoney(cart.total_discount, settings.moneyFormat))
    };

    $cartContainer.append(template(data));
    cartCallback(cart);
  };

  cartCallback = function(cart){
    $body.trigger('ajaxCart.afterCartLoad', cart);
    wc_theme_source.lib.on_cart_update(cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    getAjaxCart2();
    
    if(cart.item_count != '' || cart.item_count != null || cart.item_count != undefined || cart.item_count > 0){
      $('.cart_qty_cls').text(cart.item_count);
    }
    
  };

  adjustCart = function(){
    
     // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      $('.cart-content-here').addClass('wc_cart_loader');
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.parents('ul.QuantityBox').find('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val()),
          max = parseInt($qtySelector.attr('max'));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
        
      }

      if(qty > max) qty = max;

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        if (qty < 10) {
          qty = "0" + qty;
        }
        $qtySelector.val(qty);
      }
    });
    
    
    $body.on('change', '.ajaxcart__qty-select', function() {
      if (isUpdating) {
        return;
      }
      var $option = $(this).find('option:selected').val();

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.find('option:selected').val());

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }


    });
    
    $body.on('click', '.cart_remove_item', function(){
      var line = $(this).attr('data-line');
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback)
    });
    
    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, '')),
          max = parseInt($el.attr('max'));

      var qty = validateQty(qty);

      if(qty > max) qty = max;

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });
    
    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });
    
    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
    
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150)
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart
  };
    
  return module;

}(ajaxCart || {}, jQuery));
  $(document).on('click', '.wc_subscription_id', function(){
    var id = parseInt($(this).attr('data-subscription-id'));
    var itemId = parseInt($(this).attr('data-item-id'));
    var itemQty = parseInt($(this).attr('data-item-qty'));
    var lineItem = parseInt($(this).attr('data-line-item'));
    var ProductData = {id:itemId,quantity:itemQty,'selling_plan': id};
    /* Remove product */
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&line=" + lineItem,
      dataType: "json",
      beforeSend: function() {
        $('.cart-content-here').addClass('wc_cart_loader');
      },
      success: function(data) {     
         setTimeout(function(){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: ProductData,
          dataType: "json",
          beforeSend: function() {

          },
          success: function(data) {             
            getAjaxCart2();
            setTimeout(function(){
              $('.cart-content-here').removeClass('wc_cart_loader');
            },300);
          },
          error: function(error) {
            console.log(error+'fail');        
          }
        });

         },1000);
      },
      error: function(error) {
        console.log(error+'fail');        
      }
    });
  });
  $(document).on('change','.wc_subscription_change',function(e){
    var selctedId = parseInt($(this).val());
    var lineItem = parseInt($(this).attr('data-line-item'));
    var itemId = parseInt($(this).attr('data-item-id'));
    var itemQty = parseInt($(this).attr('data-item-qty'));
    var lineItemData = {id:itemId,quantity:itemQty,'selling_plan': selctedId};
    $.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&line=" + lineItem,
      dataType: "json",
      beforeSend: function() {
        $('.cart-content-here').addClass('wc_cart_loader');
      },
      success: function(data) {
          setTimeout(function(){
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: lineItemData,
          dataType: "json",
          beforeSend: function() {
          },
          success: function(data) {  
            getAjaxCart2();
            setTimeout(function(){
              $('.cart-content-here').removeClass('wc_cart_loader');
            },300);
          },
          error: function(error) {
            console.log(error+'change-fail');        
          }
        });
          },1000);
      },
      error: function(error) {
        console.log(error+'fail');        
      }
    });
  });